import React from "react";

import { useSelector } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import { Redirect, Link } from "react-router-dom";
import Datatable from "react-data-table-component";

import moment from "moment";

import { generatePickupPhLink } from "../../helpers";
import APIComponent from "../../components/API";
import core from "../../vendors/core-api";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import TitleHelmet from "../../partials/TitleHelmet";
import { HeaderTextWithActions } from "../../components/Base";

export default function Page() {
  const { user } = useSelector((state) => state.auth);
  return <MainComponent user={user} />;
}

function Table({ data, progressPending = false }) {
  const [searchText, setSearchText] = React.useState("");
  const filteredItems =
    searchText !== ""
      ? data.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
          );
        })
      : data;

  return (
    <>
      <Datatable
        columns={[
          {
            name: "Brand Name",
            selector: (row) => {
              return row.name;
            },
            // format: (row) => {
            //     return <Link to={"/admin/groups/" + row._id} className="font-weight-bolder text-primary">{row.name}</Link>
            // },
            sortable: true,
            style: "font-weight-bold",
          },
          {
            name: "Brand URL",
            selector: (row) => {
              return row.brand_url;
            },
            format: (row) => {
              const { brand_url = "" } = row;

              return (
                <Link
                  to={{ pathname: generatePickupPhLink(brand_url) }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {generatePickupPhLink(brand_url, false)}
                </Link>
              );
            },
          },
          {
            name: "Date Created",
            selector: (row) => {
              return moment(row.date_created).format("MMM D, YYYY hh:mm A");
            },
          },
        ]}
        data={filteredItems}
        pagination
        noHeader
        highlightOnHover
        subHeader
        subHeaderWrap={false}
        subHeaderComponent={
          <>
            <Row>
              <Col>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <i className="flaticon-search"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                </div>
              </Col>
            </Row>
          </>
        }
        progressPending={progressPending}
      />
    </>
  );
}

class MainComponent extends APIComponent {
  constructor(props) {
    super(props);

    this.state = {
      showSplashScreen: false,
      redirectTo: "",
      title: "Brands",
    };

    this.api = core("pu").get();
    this.data_url = "/analytics/brands";
  }

  handleOnDataFetched = () => {
    // let { data = [] } = this.state;
    // this.setState({ data: data.map((item) => { item.id = item._id; return item;  })});
  };

  render() {
    const { data = [], data_status = "" } = this.state,
      isLoading = data_status !== "fetched";

    return (
      <>
        <TitleHelmet title={this.state.title} />

        {this.state.showSplashScreen ? <LayoutSplashScreen /> : <></>}

        {this.state.redirectTo !== "" ? (
          <Redirect to={this.state.redirectTo} />
        ) : (
          <></>
        )}

        <HeaderTextWithActions title={this.state.title} />

        <Card>
          <Card.Body>
            <Table data={data} progressPending={isLoading} />
          </Card.Body>
        </Card>
      </>
    );
  }
}
